  export const getMockTrims = () => [
    "Base",               // Entry-level trim
    "Sport",              // Performance-oriented trim
    "Luxury",             // High-end trim with premium features
    "Premium",            // Enhanced trim with advanced features
    "Limited",            // Exclusive trim with limited availability
    "Touring",            // Trim designed for long-distance comfort
    "Performance",        // High-performance trim
    "Off-Road",           // Trim optimized for off-road driving
    "Executive",          // Business-class trim
    "Elite",              // Top-tier luxury trim
    "GT",                 // Grand Touring trim
    "RS",                 // Rally Sport trim
    "S-Line",             // Sport-oriented trim for European cars
    "Black Edition",      // Special edition with black accents
    "Platinum",           // Premium trim with advanced features
    "Titanium",           // High-end trim with durable materials
    "Adventure",          // Trim designed for rugged terrain
    "Eco",                // Fuel-efficient trim
    "Hybrid",             // Trim with hybrid engine
    "Electric",           // Fully electric trim
    "Custom",             // Customizable trim
    "Collector's Edition" // Limited edition trim for collectors
  ];

  export const getMockRegionalSpecs = () => [
    "Japanese Specs",     // Vehicles designed for the Japanese market
    "US Specs",           // Vehicles designed for the US market
    "European Specs",     // Vehicles designed for the European market
    "Middle East Specs",  // Vehicles designed for the Middle Eastern market
    "Australian Specs",   // Vehicles designed for the Australian market
    "Canadian Specs",     // Vehicles designed for the Canadian market
    "UK Specs",           // Vehicles designed for the UK market
    "South African Specs",// Vehicles designed for the South African market
    "Indian Specs",       // Vehicles designed for the Indian market
    "Chinese Specs",      // Vehicles designed for the Chinese market
    "Korean Specs",       // Vehicles designed for the Korean market
    "Russian Specs",      // Vehicles designed for the Russian market
    "Brazilian Specs",    // Vehicles designed for the Brazilian market
    "Mexican Specs",      // Vehicles designed for the Mexican market
    "Global Specs",       // Vehicles designed for worldwide compatibility
    "ASEAN Specs",        // Vehicles designed for Southeast Asian markets
    "African Specs",      // Vehicles designed for African markets
    "Nordic Specs",       // Vehicles designed for cold climates
    "GCC Specs",          // Vehicles designed for Gulf Cooperation Council countries
    "Caribbean Specs"     // Vehicles designed for Caribbean markets
  ];

  export const getMockBodyTypes = () => [
    "Sedan",              // Standard passenger car
    "SUV",                // Sport Utility Vehicle
    "Hatchback",          // Compact car with rear door
    "Truck",              // Pickup or commercial truck
    "Coupe",              // Two-door sporty car
    "Convertible",        // Car with a retractable roof
    "Van",                // Large vehicle for passengers or cargo
    "Wagon",              // Extended sedan with more cargo space
    "Crossover",          // Mix between SUV and hatchback
    "Minivan",            // Family-oriented van
    "Pickup Truck",       // Light-duty truck with an open cargo area
    "Roadster",           // Two-seat convertible sports car
    "Supercar",           // High-performance luxury sports car
    "Hypercar",           // Ultra-high-performance sports car
    "Limousine",          // Luxury extended sedan
    "Microcar",           // Extremely small car for urban use
    "Off-Road Vehicle",   // Designed for rough terrain
    "Compact Car",        // Small, fuel-efficient car
    "Luxury Sedan",       // High-end sedan with premium features
    "Sports Car",         // High-performance car
    "Electric Vehicle",   // Fully electric car
    "Hybrid Vehicle",     // Combines electric and fuel engines
    "Diesel Truck",       // Truck powered by diesel engine
    "Camper Van",         // Van equipped for camping
    "Motorhome",          // Recreational vehicle with living space
    "Cargo Van",          // Van designed for transporting goods
    "Military Vehicle",   // Specialized vehicle for military use
    "Taxi",               // Commercial passenger vehicle
    "Ambulance",          // Emergency medical vehicle
    "Hearse",             // Vehicle for transporting coffins
    "Tanker Truck",       // Truck for transporting liquids
    "Flatbed Truck",      // Truck with open flat cargo area
    "Box Truck",          // Truck with enclosed cargo area
    "Fire Truck",         // Emergency vehicle for firefighting
    "Tow Truck",          // Vehicle for towing other vehicles
    "Bus",                // Large vehicle for public transportation
    "Double-Decker Bus",  // Bus with two levels
    "Mini Truck",         // Small truck for light-duty tasks
    "Utility Vehicle",    // General-purpose vehicle
    "Tractor",            // Agricultural vehicle
    "ATV",                // All-Terrain Vehicle
    "Snowmobile",         // Vehicle for snow-covered terrain
    "Motorcycle",         // Two-wheeled motorized vehicle
    "Scooter",            // Small motorized two-wheeled vehicle
    "Bicycle",            // Non-motorized two-wheeled vehicle
    "Rickshaw",           // Three-wheeled passenger vehicle
    "Golf Cart",          // Small vehicle for golf courses
    "Buggy",              // Lightweight off-road vehicle
    "Tank",               // Armored military vehicle
  ];

  
  export const getMockMakeModels = () => [
    { id: 1, name: "Toyota Corolla", slug: "toyota-corolla" },
    { id: 2, name: "Honda Civic", slug: "honda-civic" },
    { id: 3, name: "Nissan Altima", slug: "nissan-altima" },
    { id: 4, name: "Ford Mustang", slug: "ford-mustang" },
    { id: 5, name: "Chevrolet Camaro", slug: "chevrolet-camaro" },
    { id: 6, name: "BMW 3 Series", slug: "bmw-3-series" },
    { id: 7, name: "Mercedes-Benz C-Class", slug: "mercedes-benz-c-class" },
    { id: 8, name: "Audi A4", slug: "audi-a4" },
    { id: 9, name: "Hyundai Elantra", slug: "hyundai-elantra" },
    { id: 10, name: "Kia Optima", slug: "kia-optima" },
    { id: 11, name: "Volkswagen Passat", slug: "volkswagen-passat" },
    { id: 12, name: "Subaru Impreza", slug: "subaru-impreza" },
    { id: 13, name: "Mazda 3", slug: "mazda-3" },
    { id: 14, name: "Tesla Model 3", slug: "tesla-model-3" },
    { id: 15, name: "Jeep Wrangler", slug: "jeep-wrangler" },
    { id: 16, name: "Land Rover Defender", slug: "land-rover-defender" },
    { id: 17, name: "Porsche 911", slug: "porsche-911" },
    { id: 18, name: "Lexus RX", slug: "lexus-rx" },
    { id: 19, name: "Chevrolet Tahoe", slug: "chevrolet-tahoe" },
    { id: 20, name: "Ford F-150", slug: "ford-f-150" },
  ];

  // First, create helper functions to generate realistic images for each category
const getMotorsImages = (make, model) => [
  `https://via.placeholder.com/800x600?text=${make}+${model}+Front`,
  `https://via.placeholder.com/800x600?text=${make}+${model}+Side`,
  `https://via.placeholder.com/800x600?text=${make}+${model}+Interior`,
  `https://via.placeholder.com/800x600?text=${make}+${model}+Rear`
];

const getPropertyImages = (type, bedrooms) => [
  `https://via.placeholder.com/800x600?text=${type}+Exterior`,
  `https://via.placeholder.com/800x600?text=${type}+Living+Room`,
  `https://via.placeholder.com/800x600?text=${type}+${bedrooms}+Bedroom`,
  `https://via.placeholder.com/800x600?text=${type}+Kitchen`,
  `https://via.placeholder.com/800x600?text=${type}+Bathroom`
];

const getJobImages = (title, company) => [
  `https://via.placeholder.com/800x600?text=${company}+Logo`,
  `https://via.placeholder.com/800x600?text=${company}+Office`,
  `https://via.placeholder.com/800x600?text=${title}+Work+Environment`
];

const getClassifiedImages = (title) => [
  `https://via.placeholder.com/800x600?text=${title}+Front`,
  `https://via.placeholder.com/800x600?text=${title}+Side`,
  `https://via.placeholder.com/800x600?text=${title}+Back`,
  `https://via.placeholder.com/800x600?text=${title}+Details`
];

  export const generateMockListings = () => [
   // Update the Motors listings with proper images
   {
    id: 1,
    title: "Mazda CX-5",
    category: { id: 1, name: "Motors", slug: "motors" },
    city: { id: 1, name: "Dubai" },
    price: 20000,
    currency: "AED",
    year: 2020,
    kilometers: 15000,
    bodyType: "SUV",
    isInsured: true,
    verified: true,
    description: "A reliable SUV with low mileage and excellent condition.",
    tags: ["SUV", "Mazda", "Low Mileage"],
    condition: "Used",
    images: getMotorsImages("Mazda", "CX-5"),
    phoneNumber: "+971 50 123 4567",
    email: "seller@example.com",
    location: "Dubai Marina",
    latitude: 25.0717,
    longitude: 55.1397,
    created_at: "2023-04-15T12:00:00Z",
    updated_at: "2023-04-15T12:00:00Z",
    isPremium: true,
    detailsAvailable: true
  },
  
  // Update remaining motor listings in similar fashion
  {
    id: 2,
    title: "Toyota Corolla",
    category: { id: 1, name: "Motors", slug: "motors" },
    city: { id: 2, name: "Abu Dhabi" },
    price: 15000,
    year: 2018,
    kilometers: 30000,
    bodyType: "Sedan",
    isInsured: false,
    verified: true,
    description: "A fuel-efficient sedan perfect for city driving.",
    tags: ["Sedan", "Toyota", "Fuel Efficient"],
    condition: "Used",
    images: getMotorsImages("Toyota", "Corolla"),
    isPremium: false
  },
    {
      id: 3,
      title: "Honda Civic",
      category: "Motors",
      city: "Sharjah",
      price: 18000,
      year: 2019,
      kilometers: 20000,
      bodyType: "Sedan",
      isInsured: true,
      verified: false,
      description: "A stylish sedan with modern features and great performance.",
      tags: ["Sedan", "Honda", "Modern Features"],
      condition: "Used",
    },
    {
      id: 4,
      title: "Ford Mustang",
      category: "Motors",
      city: "Dubai",
      price: 50000,
      year: 2021,
      kilometers: 10000,
      bodyType: "Coupe",
      isInsured: true,
      verified: true,
    },
    {
      id: 5,
      title: "Chevrolet Tahoe",
      category: "Motors",
      city: "Abu Dhabi",
      price: 40000,
      year: 2020,
      kilometers: 25000,
      bodyType: "SUV",
      isInsured: false,
      verified: false,
      description: "A spacious and powerful SUV, perfect for family trips and off-road adventures.",
      tags: ["SUV", "Chevrolet", "Family Car", "Off-Road"],
      condition: "Used",
    },
    {
      id: 6,
      title: "BMW X5",
      category: "Motors",
      city: "Dubai",
      price: 60000,
      year: 2022,
      kilometers: 5000,
      bodyType: "SUV",
      isInsured: true,
      verified: true,
      description: "A luxury SUV with advanced features and low mileage, ideal for city and highway driving.",
      tags: ["SUV", "BMW", "Luxury", "Low Mileage"],
      condition: "New",
    },
    {
      id: 7,
      title: "Mercedes-Benz C-Class",
      category: "Motors",
      city: "Sharjah",
      price: 35000,
      year: 2019,
      kilometers: 15000,
      bodyType: "Sedan",
      isInsured: true,
      verified: false,
      description: "A premium sedan with a sleek design and excellent performance.",
      tags: ["Sedan", "Mercedes-Benz", "Premium", "Performance"],
      condition: "Used",
    },
    {
      id: 8,
      title: "Audi A4",
      category: "Motors",
      city: "Dubai",
      price: 30000,
      year: 2020,
      kilometers: 12000,
      bodyType: "Sedan",
      isInsured: false,
      verified: true,
      description: "A stylish and fuel-efficient sedan with modern features.",
      tags: ["Sedan", "Audi", "Fuel Efficient", "Modern Features"],
      condition: "Used",
    },
    {
      id: 9,
      title: "Tesla Model 3",
      category: "Motors",
      city: "Abu Dhabi",
      price: 70000,
      year: 2022,
      kilometers: 8000,
      bodyType: "Sedan",
      isInsured: true,
      verified: true,
      description: "An electric sedan with cutting-edge technology and impressive range.",
      tags: ["Sedan", "Tesla", "Electric", "Technology"],
      condition: "New",
    },
    {
      id: 10,
      title: "Jeep Wrangler",
      category: "Motors",
      city: "Dubai",
      price: 45000,
      year: 2021,
      kilometers: 10000,
      bodyType: "SUV",
      isInsured: true,
      verified: false,
      description: "A rugged SUV designed for off-road adventures and tough terrains.",
      tags: ["SUV", "Jeep", "Off-Road", "Rugged"],
      condition: "Used",
    },
    {
      id: 11,
      title: "Nissan Altima",
      category: "Motors",
      city: "Sharjah",
      price: 22000,
      year: 2021,
      kilometers: 18000,
      bodyType: "Sedan",
      isInsured: true,
      verified: true,
      description: "A reliable sedan with a comfortable interior and great fuel efficiency.",
      tags: ["Sedan", "Nissan", "Reliable", "Fuel Efficient"],
      condition: "Used",
    },
    {
      id: 12,
      title: "Hyundai Tucson",
      category: "Motors",
      city: "Dubai",
      price: 25000,
      year: 2020,
      kilometers: 12000,
      bodyType: "SUV",
      isInsured: false,
      verified: false,
      description: "A compact SUV with modern features and a stylish design.",
      tags: ["SUV", "Hyundai", "Compact", "Stylish"],
      condition: "Used",
    },
    {
      id: 13,
      title: "Chevrolet Camaro",
      category: "Motors",
      city: "Abu Dhabi",
      price: 45000,
      year: 2019,
      kilometers: 15000,
      bodyType: "Coupe",
      isInsured: true,
      verified: true,
      description: "A high-performance coupe with a bold design and powerful engine.",
      tags: ["Coupe", "Chevrolet", "Performance", "Bold Design"],
      condition: "Used",
    },
    {
      id: 14,
      title: "Volkswagen Passat",
      category: "Motors",
      city: "Sharjah",
      price: 18000,
      year: 2018,
      kilometers: 25000,
      bodyType: "Sedan",
      isInsured: false,
      verified: false,
      description: "A practical sedan with a spacious interior and smooth ride.",
      tags: ["Sedan", "Volkswagen", "Practical", "Spacious"],
      condition: "Used",
    },
    {
      id: 15,
      title: "Subaru Outback",
      category: "Motors",
      city: "Dubai",
      price: 30000,
      year: 2021,
      kilometers: 10000,
      bodyType: "Wagon",
      isInsured: true,
      verified: true,
      description: "A versatile wagon with all-wheel drive and ample cargo space.",
      tags: ["Wagon", "Subaru", "Versatile", "All-Wheel Drive"],
      condition: "New",
    },
  
    // Property Category
    {
      id: 11,
      title: "Luxury Apartment",
      category: { id: 2, name: "Property", slug: "property" },
      city: { id: 2, name: "Abu Dhabi" },
      price: 500000,
      bedrooms: 3,
      bathrooms: 2,
      size: 1500,
      amenities: ["Pool", "Gym"],
      verified: false,
      description: "A luxurious apartment with modern amenities and a prime location.",
      tags: ["Apartment", "Luxury", "Pool", "Gym"],
      condition: "New",
      images: getPropertyImages("Apartment", 3),
      isPremium: true
    },
    {
      id: 12, title: "Villa with Garden", category: "Property", city: "Dubai", price: 1200000, bedrooms: 5, bathrooms: 4, size: 3000, amenities: ["Garden", "Garage"], verified: true, description: "A spacious villa with a private garden and ample parking space.", tags: ["Villa", "Garden", "Spacious", "Garage"], condition: "New"
    },
    {
      id: 13, title: "Studio Apartment", category: "Property", city: "Sharjah", price: 150000, bedrooms: 1, bathrooms: 1, size: 500, amenities: ["Parking"], verified: true, description: "A cozy studio apartment ideal for singles or couples.", tags: ["Studio", "Apartment", "Cozy", "Parking"], condition: "Used"
    },
    {
      id: 14, title: "Penthouse", category: "Property", city: "Dubai", price: 2500000, bedrooms: 4, bathrooms: 3, size: 4000, amenities: ["Pool", "Gym", "Terrace"], verified: false, description: "A luxurious penthouse with stunning views and premium amenities.", tags: ["Penthouse", "Luxury", "Terrace", "Pool"], condition: "New"
    },
    {
      id: 15, title: "Office Space", category: "Property", city: "Abu Dhabi", price: 800000, bedrooms: null, bathrooms: 2, size: 2000, amenities: ["Parking", "Conference Room"], verified: true, description: "A modern office space with excellent facilities for businesses.", tags: ["Office", "Modern", "Conference Room", "Parking"], condition: "New"
    },
    {
      id: 16, title: "Beachfront Villa", category: "Property", city: "Dubai", price: 5000000, bedrooms: 6, bathrooms: 5, size: 5000, amenities: ["Private Beach", "Pool", "Garage"], verified: true, description: "A stunning beachfront villa with private access to the beach.", tags: ["Villa", "Beachfront", "Luxury", "Private Beach"], condition: "New"
    },
    {
      id: 17, title: "Shared Apartment", category: "Property", city: "Sharjah", price: 100000, bedrooms: 2, bathrooms: 1, size: 800, amenities: ["Parking"], verified: false, description: "An affordable shared apartment with basic amenities.", tags: ["Apartment", "Shared", "Affordable", "Parking"], condition: "Used"
    },
    {
      id: 18, title: "Commercial Warehouse", category: "Property", city: "Abu Dhabi", price: 2000000, bedrooms: null, bathrooms: 1, size: 10000, amenities: ["Loading Dock"], verified: true, description: "A large commercial warehouse with a loading dock for logistics.", tags: ["Warehouse", "Commercial", "Spacious", "Loading Dock"], condition: "New"
    },
    {
      id: 19, title: "Luxury Penthouse", category: "Property", city: "Dubai", price: 8000000, bedrooms: 5, bathrooms: 4, size: 6000, amenities: ["Pool", "Gym", "Terrace"], verified: true, description: "An exclusive penthouse with premium features and breathtaking views.", tags: ["Penthouse", "Luxury", "Exclusive", "Terrace"], condition: "New"
    },
    {
      id: 20, title: "Affordable Studio", category: "Property", city: "Sharjah", price: 80000, bedrooms: 1, bathrooms: 1, size: 400, amenities: ["Parking"], verified: false, description: "A budget-friendly studio apartment in a convenient location.", tags: ["Studio", "Affordable", "Budget-Friendly", "Parking"], condition: "Used"
    },
  
    {
      id: 16,
      title: "Software Engineer",
      category: { id: 3, name: "Jobs", slug: "jobs" },
      city: { id: 1, name: "Dubai" },
      salary: 15000,
      experience: "3 years",
      education: "Bachelor's Degree",
      verified: true,
      description: "Develop and maintain software applications with a focus on scalability and performance.",
      tags: ["Software", "Engineer", "Development", "Programming"],
      skills: ["JavaScript", "Python", "SQL"],
      images: getJobImages("Software Engineer", "Tech Company"),
      isPremium: false
    },
    {
      id: 17, title: "Marketing Manager", category: "Jobs", city: "Abu Dhabi", salary: 20000, experience: "5 years", education: "Master's Degree", verified: false, description: "Plan and execute marketing strategies to drive brand growth and customer engagement.", tags: ["Marketing", "Manager", "Strategy", "Branding"], skills: ["SEO", "Content Marketing", "Leadership"]
    },
    {
      id: 18, title: "Graphic Designer", category: "Jobs", city: "Sharjah", salary: 10000, experience: "2 years", education: "Diploma", verified: true, description: "Create visually appealing designs for digital and print media.", tags: ["Graphic", "Designer", "Creativity", "Design"], skills: ["Photoshop", "Illustrator", "UI/UX"]
    },
    {
      id: 19, title: "Data Scientist", category: "Jobs", city: "Dubai", salary: 25000, experience: "4 years", education: "Master's Degree", verified: true, description: "Analyze complex datasets to extract insights and support data-driven decision-making.", tags: ["Data", "Scientist", "Analytics", "Machine Learning"], skills: ["Python", "R", "Machine Learning"]
    },
    {
      id: 20, title: "Sales Executive", category: "Jobs", city: "Abu Dhabi", salary: 12000, experience: "3 years", education: "Bachelor's Degree", verified: false, description: "Drive sales growth by building relationships with clients and closing deals.", tags: ["Sales", "Executive", "Client Relations", "Negotiation"], skills: ["CRM", "Negotiation", "Communication"]
    },
    {
      id: 21, title: "Accountant", category: "Jobs", city: "Dubai", salary: 10000, experience: "2 years", education: "Bachelor's Degree", verified: true, description: "Manage financial records and ensure compliance with accounting standards.", tags: ["Accountant", "Finance", "Compliance", "Records"], skills: ["Excel", "QuickBooks", "Taxation"]
    },
    {
      id: 22, title: "HR Manager", category: "Jobs", city: "Abu Dhabi", salary: 18000, experience: "5 years", education: "Master's Degree", verified: false, description: "Oversee recruitment, employee relations, and organizational development.", tags: ["HR", "Manager", "Recruitment", "Employee Relations"], skills: ["Leadership", "Conflict Resolution", "HR Policies"]
    },
    {
      id: 23, title: "Web Developer", category: "Jobs", city: "Sharjah", salary: 12000, experience: "3 years", education: "Bachelor's Degree", verified: true, description: "Design and develop responsive websites and web applications.", tags: ["Web", "Developer", "Frontend", "Backend"], skills: ["HTML", "CSS", "JavaScript", "React"]
    },
    {
      id: 24, title: "Project Manager", category: "Jobs", city: "Dubai", salary: 22000, experience: "6 years", education: "Master's Degree", verified: true, description: "Lead and manage projects to ensure timely delivery and quality outcomes.", tags: ["Project", "Manager", "Leadership", "Planning"], skills: ["Agile", "Scrum", "Risk Management"]
    },
    {
      id: 25, title: "Customer Support Specialist", category: "Jobs", city: "Abu Dhabi", salary: 8000, experience: "1 year", education: "Diploma", verified: false, description: "Provide excellent customer service and resolve client issues efficiently.", tags: ["Customer Support", "Specialist", "Service", "Resolution"], skills: ["Communication", "Problem Solving", "CRM"]
    },
    // Community Category
    {
      id: 21, title: "Yoga Classes", category: "Community", city: "Dubai", price: 500, description: "Weekly yoga classes for beginners.", verified: true, tags: ["Yoga", "Fitness", "Beginners"]
    },
    {
      id: 22, title: "Cooking Workshop", category: "Community", city: "Abu Dhabi", price: 300, description: "Learn to cook Italian cuisine.", verified: false, tags: ["Cooking", "Workshop", "Italian Cuisine"]
    },
    {
      id: 23, title: "Photography Club", category: "Community", city: "Sharjah", price: 200, description: "Join our photography club and improve your skills.", verified: true, tags: ["Photography", "Club", "Skills"]
    },
    {
      id: 24, title: "Book Club", category: "Community", city: "Dubai", price: 100, description: "Monthly book discussions and meetups.", verified: true, tags: ["Books", "Club", "Meetups"]
    },
    {
      id: 25, title: "Fitness Bootcamp", category: "Community", city: "Abu Dhabi", price: 800, description: "Intensive fitness training sessions.", verified: false, tags: ["Fitness", "Bootcamp", "Training"]
    },
    {
      id: 26, title: "Art Exhibition", category: "Community", city: "Dubai", price: 100, description: "Explore local art and meet artists.", verified: true, tags: ["Art", "Exhibition", "Artists"]
    },
    {
      id: 27, title: "Music Festival", category: "Community", city: "Abu Dhabi", price: 500, description: "Live performances by top artists.", verified: false, tags: ["Music", "Festival", "Live Performances"]
    },
    {
      id: 28, title: "Tech Meetup", category: "Community", city: "Sharjah", price: 200, description: "Networking event for tech enthusiasts.", verified: true, tags: ["Tech", "Meetup", "Networking"]
    },
    {
      id: 29, title: "Charity Run", category: "Community", city: "Dubai", price: 50, description: "Join the run for a good cause.", verified: true, tags: ["Charity", "Run", "Good Cause"]
    },
    {
      id: 30, title: "Cooking Class", category: "Community", city: "Abu Dhabi", price: 300, description: "Learn to cook gourmet meals.", verified: false, tags: ["Cooking", "Class", "Gourmet Meals"]
    },
  
  
    // Classifieds Category
    // And for classifieds
  {
    id: 26,
    title: "Used iPhone 12",
    category: { id: 4, name: "Classifieds", slug: "classifieds" },
    city: { id: 1, name: "Dubai" },
    price: 3000,
    condition: "Used",
    warranty: "No",
    verified: true,
    description: "A used iPhone 12 in good condition.",
    tags: ["iPhone", "Used", "Electronics"],
    images: getClassifiedImages("iPhone+12"),
    isPremium: false
  },
    {
      id: 27, title: "Dining Table Set", category: "Classifieds", city: "Abu Dhabi", price: 1500, condition: "New", warranty: "Yes", verified: false, description: "A brand-new dining table set with six chairs.", tags: ["Furniture", "Dining Table", "New"]
    },
    {
      id: 28, title: "Gaming Laptop", category: "Classifieds", city: "Sharjah", price: 5000, condition: "Used", warranty: "Yes", verified: true, description: "A high-performance gaming laptop with warranty.", tags: ["Laptop", "Gaming", "Electronics"]
    },
    {
      id: 29, title: "Mountain Bike", category: "Classifieds", city: "Dubai", price: 800, condition: "Used", warranty: "No", verified: true, description: "A durable mountain bike for outdoor adventures.", tags: ["Bike", "Mountain", "Outdoor"]
    },
    {
      id: 30, title: "Smart TV", category: "Classifieds", city: "Abu Dhabi", price: 2500, condition: "New", warranty: "Yes", verified: false, description: "A brand-new smart TV with 4K resolution.", tags: ["TV", "Smart", "Electronics"]
    },
    {
      id: 31, title: "Used MacBook Pro", category: "Classifieds", city: "Dubai", price: 4000, condition: "Used", warranty: "No", verified: true, description: "A used MacBook Pro in excellent condition.", tags: ["MacBook", "Laptop", "Used"]
    },
    {
      id: 32, title: "Office Chair", category: "Classifieds", city: "Abu Dhabi", price: 500, condition: "New", warranty: "Yes", verified: false, description: "A comfortable office chair with ergonomic design.", tags: ["Furniture", "Office Chair", "New"]
    },
    {
      id: 33, title: "Electric Scooter", category: "Classifieds", city: "Sharjah", price: 1500, condition: "Used", warranty: "No", verified: true, description: "A used electric scooter in good working condition.", tags: ["Scooter", "Electric", "Used"]
    },
    {
      id: 34, title: "Smartphone", category: "Classifieds", city: "Dubai", price: 2500, condition: "New", warranty: "Yes", verified: true, description: "A brand-new smartphone with advanced features.", tags: ["Smartphone", "New", "Electronics"]
    },
    {
      id: 35, title: "Gaming Console", category: "Classifieds", city: "Abu Dhabi", price: 2000, condition: "Used", warranty: "No", verified: false, description: "A used gaming console in good condition.", tags: ["Gaming", "Console", "Used"]
    },
  ];